import { X } from 'lucide-react';
import type { ApprovalRule, ApprovalOperator } from '@netsuite-ai/types';

const OPERATORS: ApprovalOperator[] = ['eq', 'gt', 'lt', 'gte', 'lte', 'contains'];

interface Props {
  value: ApprovalRule[];
  onChange: (v: ApprovalRule[]) => void;
}

export default function ApprovalRules({ value: rules, onChange }: Props) {
  function add() {
    onChange([...rules, { field: '', operator: 'eq', value: '' }]);
  }

  function remove(i: number) {
    onChange(rules.filter((_, j) => j !== i));
  }

  function update(i: number, patch: Partial<ApprovalRule>) {
    onChange(rules.map((r, j) => (j === i ? { ...r, ...patch } : r)));
  }

  return (
    <div className="space-y-3">
      {rules.map((rule, i) => (
        <div
          key={i}
          className="flex flex-col gap-2 sm:flex-row sm:items-center"
        >
          <input
            type="text"
            placeholder="Field"
            value={rule.field}
            onChange={(e) => update(i, { field: e.target.value })}
            className="w-full rounded border border-neutral-300 px-3 py-2 text-sm outline-none focus:border-neutral-500 sm:flex-1"
          />
          <div className="flex items-center gap-2 sm:contents">
            <select
              value={rule.operator}
              onChange={(e) =>
                update(i, { operator: e.target.value as ApprovalOperator })
              }
              className="shrink-0 rounded border border-neutral-300 px-2 py-2 text-sm outline-none focus:border-neutral-500"
            >
              {OPERATORS.map((op) => (
                <option key={op} value={op}>
                  {op}
                </option>
              ))}
            </select>
            <input
              type="text"
              placeholder="Value"
              value={String(rule.value)}
              onChange={(e) => update(i, { value: e.target.value })}
              className="min-w-0 flex-1 rounded border border-neutral-300 px-3 py-2 text-sm outline-none focus:border-neutral-500 sm:flex-1"
            />
            <button
              onClick={() => remove(i)}
              className="shrink-0 text-neutral-400 hover:text-neutral-600"
              aria-label="Remove rule"
            >
              <X size={16} />
            </button>
          </div>
        </div>
      ))}
      <button
        onClick={add}
        className="w-full rounded border border-dashed border-neutral-300 py-2 text-sm text-neutral-500 hover:bg-neutral-50"
      >
        Add approval rule
      </button>
    </div>
  );
}
